import apiClient from '../apiClient';

export const fetchNotifications = async ({ unseenOnly = false, limit = 20 } = {}) => {
  const response = await apiClient.get('/notifications', {
    params: {
      unseenOnly,
      limit,
    },
  });

  return response.data ?? [];
};

export const getUnseenNotificationCount = async () => {
  const response = await apiClient.get('/notifications/unseen-count');
  return Number(response.data ?? 0);
};

export const createNotification = async (payload) => {
  const response = await apiClient.post('/notifications', payload);
  return response.data;
};

export const markNotificationSeen = async (notificationId, seen = true) => {
  const response = await apiClient.patch(`/notifications/${notificationId}/seen`, {
    seen,
  });

  return response.data;
};

export const markAllNotificationsSeen = async () => {
  const response = await apiClient.post('/notifications/mark-all-seen');
  return response.data;
};
